import { GlobalNavigationLinkCollection, GlobalNavigationLinkProps } from '@/components';

export const navLinks: GlobalNavigationLinkCollection<GlobalNavigationLinkProps> = {
  primaryNavLinks: [
    {
      link: 'https://www.curtin.edu.au/about',
      text: 'About',
    },
    {
      link: 'https://www.curtin.edu.au/study',
      text: 'Study',
    },
    {
      link: 'https://research.curtin.edu.au/',
      text: 'Research',
    },
    {
      link: 'https://www.curtin.edu.au/friends',
      text: 'Alumni & Friends',
    },
    {
      link: 'https://www.curtin.edu.au/engage',
      text: 'Engage',
    },
    {
      link: 'https://www.curtin.edu.au/news',
      text: 'News',
    },
    {
      link: 'https://www.curtin.edu.au/about/contact',
      text: 'Contact',
    },
  ],
  secondaryNavLinks: [
    {
      link: 'https://www.curtin.edu.au/events',
      text: 'Events',
    },
    {
      link: 'https://www.curtin.edu.au/library',
      text: 'Library',
    },
    {
      link: 'https://www.curtin.edu.au/students',
      text: 'Current students',
    },
    {
      link: 'https://oasis.curtin.edu.au/',
      text: 'OASIS',
    },
    {
      link: 'https://staffportal.curtin.edu.au/',
      text: 'Staff',
    },
    {
      link: 'https://payments.curtin.edu.au/',
      text: 'ePay',
    },
    {
      link: 'https://properties.curtin.edu.au/visit-curtin/campus-maps',
      text: 'Campus maps',
    },
  ],
};
